import { computed, defineComponent, PropType, ref } from "vue";
import InvoiceUploader, { UploadError } from "./InvoiceUploader";
import InputCheckbox from "../forms/InputCheckbox";
import Utils, { UserError } from "../utils/Utils";
import Tracking from "../utils/Tracking";
import { BaseOrderJson } from "../OrderForm";

export default defineComponent({
    components: {
        InputCheckbox,
        InvoiceUploader,
    },

    template: `
        <div class="UploadBox">
            <div class="UploadBox__head">
                <div class="UploadBox__form">
                    <InputCheckbox v-if="!uploaded || !terms" class="UploadBox__terms" :title="termslabel" v-model="terms" :error="errors.terms ? 'required' : null" />

                    <InvoiceUploader
                        :class="{ 'InvoiceUploader--error': errors.file }"
                        :sme="sme"
                        :disabled="!terms"
                        :label_upload_mobile="label_upload_mobile"
                        :globalfiles="globalfiles"

                        @uploading="onUploading"
                        @uploaded="onUploaded"
                        @error="onError"
                    />

                    <p v-if="errortext" class="UploadBox__errortext">{{ errortext }}</p>

                    <div v-if="visible_footer || uploaded" class="UploadBox__footer">
                        <button v-if="visible_back" type="button" class="button button--back" @click="$emit('back')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5401 20L11.4599 19.0801L2.37983 10L11.4599 0.919888L10.5401 0L0.540054 10L10.5401 20Z" fill="#005537"/>
                            </svg>
                        </button>

                        <button v-if="visible_next" type="button" class="button button--master UploadBox__next" :disabled="!errorsmode && !valid" @click="onNext">{{ label_next }}</button>
                    </div>
                </div>
            </div>
        </div>
    `,

    emits: [
        'back',
        'next',
    ],

    props: {
        options: { type: Object as PropType<BaseOrderJson>, required: true },

        sme: { type: Boolean, default: false },

        errorsmode: { type: Boolean, default: false },
        globalfiles: { type: Boolean },

        visible_back: { type: Boolean, default: false },
        visible_next: { type: Boolean, default: true },
        visible_footer: { type: Boolean, default: true },

        label_next: { type: String, default: 'Dalej' },
        label_upload_mobile: { type: String, default: 'Wgraj swoją fakturę' },
    },

    setup(props, ctx) {
        const terms = ref(props.options.terms);
        const soft = ref(null as boolean);
        const errortext = ref(null as string);

        const errors = ref({
            terms: false,
            file: false,
        });

        const termslabel = computed(() => {
            return `Zapoznałem/łam się i akceptuję <a href="/polityka-prywatnosci" target="_blank">Politykę Prywatności</a> i <a href="/regulamin" target="_blank">Regulamin</a> serwisu.`;
        });

        const uploaded = computed(() => {
            return props.options.documents.length;
        });

        const valid = computed(() => {
            return terms.value && uploaded.value;
        });

        function onUploading() {
            soft.value = null;
        }

        function onUploaded() {
            soft.value = null;

            try {
                asserterrors();
            } catch (e) {
            }
        }

        function onError(e: UploadError) {
            soft.value = e.soft;
        }

        function asserterrors() {
            errortext.value = null;

            if (props.errorsmode && !valid.value) {
                errors.value.terms = !terms.value;
                errors.value.file = !props.options.documents.length;

                throw new UserError('Zaakceptuj regulaminy i wgraj fakturę, aby przejść dalej.');
            }
        }

        async function onNext() {
            try {
                errortext.value = null;

                asserterrors();

                if (!props.options.sme) {
                    let ev = ['click', 'invoiceupload'];

                    if ($('.vhome').length) {
                        ev.push('mainpage');
                    } else {
                        ev.push('form');
                    }

                    await Tracking.doEvent(ev.join('_'));
                }

                await Utils.setCart('accept-invoice');

                ctx.emit('next');
            } catch (e) {
                if (e instanceof UserError) {
                    errortext.value = e.message;
                }

                console.log(e);
            }
        }

        return {
            terms,
            soft,
            errors,
            errortext,

            termslabel,
            uploaded,
            valid,

            onUploading,
            onUploaded,
            onError,
            onNext,
        }
    },
});
